<template>
    <v-sheet>
        <v-radio-group v-model="form.schedule.type" row hide-details @change="emit">
            <template v-for="item in items">
                <v-radio :label="item.text" :value="item.value" :key="item.value" />
            </template>
        </v-radio-group>

        <v-expand-transition>
            <v-sheet v-show="isTypeOnTime">
                <v-row class="mt-8 mx-n4 mb-n4">
                    <v-col class="pa-4">
                        <v-date-field v-model="form.schedule.date" v-bind="attrs_input" @input="emit" />
                    </v-col>
                    <v-col class="pa-4">
                        <schedule-hour v-model="form.schedule" v-bind="attrs_input" @input="emit" />
                    </v-col>
                    <v-col class="pa-4">
                        <schedule-minute v-model="form.schedule" v-bind="attrs_input" @input="emit" />
                    </v-col>
                    <v-col class="pa-4" cols="12">
                        <p class="font-size-14 grey--text text--lighten-2">
                            ※ 예약 일정 설정시 해당 시간 전에는 참여가 불가능합니다. <br />
                            예약 시간 30분 전에 알림톡으로 모든 참석자에게 참석알림이 발송됩니다.
                        </p>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-expand-transition>
    </v-sheet>
</template>

<script>
import { attrs_input } from "@/assets/variables/attrs";
import { initInterview } from "@/assets/variables/inits";
import { INTERVIEW_SCHEDULE_TYPES } from "@/assets/variables/constants";

import vDateField from "@/components/plugins/vuetify/v-date-field.vue";
import ScheduleHour from "./schedule/schedule-hour.vue";
import ScheduleMinute from "./schedule/schedule-minute.vue";

export default {
    components: {
        vDateField,
        ScheduleHour,
        ScheduleMinute,
    },
    props: {
        value: { type: Object, default: initInterview },
    },

    data: () => ({
        form: initInterview(),

        items: Object.values(INTERVIEW_SCHEDULE_TYPES),
        attrs_input,
    }),
    computed: {
        isTypeOnTime() {
            return this.form.schedule.type == INTERVIEW_SCHEDULE_TYPES.ON_TIME.value;
        },
    },
    methods: {
        sync() {
            this.form = initInterview(this.value);
        },
        emit() {
            this.form = initInterview(this.form);
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>